import script from "./index.vue?vue&type=script&setup=true&name=AbnormalMonitoring&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=AbnormalMonitoring&lang=js"

import "./index.vue?vue&type=style&index=0&id=b4d1bcb2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4d1bcb2"]])

export default __exports__